<template>
  <div id="app">
    <div id="nprogress-container" :class="{ light: navLight && desktop }" />
    <div v-if="showLoader" class="sk-container">
      <div class="sk-content">
        <div class="sk-plane"></div>
      </div>
    </div>
    <main-header :is-white-navbar="isWhiteNavbar" :nav-light="navLight" />
    <div role="main">
      <router-view v-if="navLight && !isWhiteNavbar" />
      <transition
        v-else
        name="fade"
        mode="out-in"
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut"
      >
        <router-view />
      </transition>
    </div>
    <main-footer />
    <!-- Back to top -->
    <a
      id="back-to-top"
      v-scroll-to="'#topnav'"
      :class="[$store.getters['website/dataWebsite']('loadedChat') ? 'with-chat' : '']"
      href="javascript: void(0);"
      class="btn btn-icon btn-soft-primary back-to-top"
    >
      <arrow-up-icon class="icons" />
    </a>
    <!-- End back to top -->
    <!-- Cookie consent -->
    <cookie-consent
      v-if="cookieLawData && cookieLawData.show"
      ref="cookieConsent"
      class="cookie-consent"
      storage-name="cookie:consent"
    >
      <proglass-markdown :source="cookieLawData.content" />
      <template v-slot:link><div></div></template>
      <template v-slot:button>
        <button class="btn btn-pills btn-primary btn-block" @click="consent">
          {{ cookieLawData.buttonText }}
        </button>
      </template>
    </cookie-consent>
    <!-- End cookie consent -->
  </div>
</template>

<script>
import MainHeader from 'container/Header';
import MainFooter from 'container/Footer';
import { ArrowUpIcon } from 'vue-feather-icons';
import MediaQueriesMixin from 'mixins/MediaQueriesMixin';
import { SET_WEBSITE_PROPERTY } from 'store/actions/website';
import { i18n } from '@/setup/i18n';

export default {
  name: 'ProGlass',

  components: {
    MainHeader,
    MainFooter,
    ArrowUpIcon,
    CookieConsent: () =>
      import(/* webpackChunkName: "components/cookie-consent" */ 'v-cookie-consent')
  },

  mixins: [MediaQueriesMixin],

  data: () => ({
    isWhiteNavbar: false,
    navLight: false
  }),

  computed: {
    showLoader() {
      return this.$store.getters['ui/dataUI']('loader');
    },

    commonData() {
      const commonData = this.$store.getters['website/dataWebsite']('commonApp');
      if (commonData) this.checkChatComponent(commonData.enabledChat);
      return commonData;
    },

    cookieLawData() {
      return this.commonData ? this.commonData.cookieLaw : null;
    }
  },

  watch: {
    $route(to) {
      if (['404', 'error'].indexOf(to.name) > -1) {
        this.isWhiteNavbar = false;
        this.navLight = false;
      } else {
        this.isWhiteNavbar = this.commonData ? this.commonData.whiteNavbar : false;
        this.navLight = this.commonData ? this.commonData.lightNavbar : false;
      }
    }
  },

  mounted() {
    this.$store.watch(
      getters => getters.error,
      val => {
        if (val) {
          this.$router.push({ name: 'error' });
        }
      }
    );
  },

  methods: {
    consent() {
      localStorage.setItem('cookie:consent', 'true');
      this.$refs.cookieConsent.checkConsent();
    },

    checkChatComponent(show) {
      const loadedChat = this.$store.getters['website/dataWebsite']('loadedChat');
      if (show && !loadedChat) {
        window.CRISP_RUNTIME_CONFIG = {
          locale: i18n().locale
        };
        this.$crisp.load(process.env.CRISP_WEBSITE_ID);
        this.$store.dispatch(`website/${SET_WEBSITE_PROPERTY}`, {
          field: 'loadedChat',
          value: true
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
div[role='main'] {
  min-height: calc(100vh - 418px);
}
</style>
